import { useState } from "react";

import { QueryBarWebsiteItem } from "@similarweb/ui-components";

import { ClickOutsideWrapper } from "app/custom-hooks/useClickOutside";
import { translate } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";
import { AutocompleteWebsitesMainItem } from "pro-features/components/AutocompleteWebsites/AutocompleteWebsitesMainItem";
import type { IWebsitePageResult } from "pro-features/components/AutocompleteWebsites/types";

import { AutocompleteWrapper } from "./StyledComponents";
import type { ISelectedDomain } from "./types";

interface DomainsFilterProps {
    onDomainSelect?: (domain: ISelectedDomain | null) => void;
}

export const DomainsFilter = ({ onDomainSelect }: DomainsFilterProps) => {
    const [isAutocompleteOpen, setIsAutocompleteOpen] = useState(true);
    const [selectedDomain, setSelectedDomain] = useState<ISelectedDomain | null>(null);

    const handleChipClick = () => {
        setIsAutocompleteOpen(true);
        setSelectedDomain(null);
        onDomainSelect?.(null);

        allTrackers.dispatchTrackEvent("Button", "click", `SEO Agent/Choose domain`);
    };

    const onItemSelected = (item: IWebsitePageResult) => {
        setIsAutocompleteOpen(false);

        const domain: ISelectedDomain = {
            name: item.name,
            image: item.image || "",
        };
        setSelectedDomain(domain);
        onDomainSelect?.(domain);

        allTrackers.dispatchTrackEvent("Button", "click", `SEO Agent/Choose domain/${domain.name}`);
    };

    const onPressEnter = (_, item: IWebsitePageResult) => {
        onItemSelected(item);
    };

    return !isAutocompleteOpen ? (
        <QueryBarWebsiteItem
            isCompare={false}
            text={selectedDomain?.name || translate("autocomplete.competitive.loader.placeholder.text")}
            image={selectedDomain?.image || ""}
            onItemClick={handleChipClick}
            width="150px"
        />
    ) : (
        <AutocompleteWrapper>
            <ClickOutsideWrapper onClickOutside={() => setIsAutocompleteOpen(false)}>
                <AutocompleteWebsitesMainItem
                    className="AutocompleteWebsiteQueryBar"
                    onClick={onItemSelected}
                    onClose={() => setIsAutocompleteOpen(false)}
                    recentSearches={[]}
                    overrideEnterFunc={onPressEnter}
                    autocompleteProps={{
                        placeholder: translate("ai.agent.seo.form.domain.placeholder"),
                        width: "100%",
                        top: 0,
                    }}
                />
            </ClickOutsideWrapper>
        </AutocompleteWrapper>
    );
}; 